import Header from "../Header";
import Footer from "../Footer";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAuthToken } from "../../utils/auth";
import DataTable from "react-data-table-component";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import DialogBox from "../OtherComponents/DialogBox";
import { fetchAllUsers } from "../../utils/UserComponents";
import ReactPaginate from "react-paginate";

const Base_Url = process.env.REACT_APP_BASE_URL;

const AllUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchEmail, setSearchEmail] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page")) || 1;

  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);

  const [open, setOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState([]);

  const handleClose = () => {
    setOpen(false);
  };

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    await fetchAllUsers(page, limit, searchEmail, setUsers, setTotalPages);
    setLoading(false);
  }, [page, searchEmail, limit]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // Update the URL query parameters when the page or limit changes
  const updateUrlParams = (newPage, newLimit) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("page", newPage);
    searchParams.set("limit", newLimit);
    navigate({ search: searchParams.toString() });
  };

  const handleView = (user) => {
    navigate(`/view/user/profile/${user._id}`);
  };

  const handleDelete = async () => {
    const token = getAuthToken();
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const res = await axios.post(
        `${Base_Url}/api/user/delete/${userToDelete._id}`
      );
      setTimeout(() => {
        toast.success(res.data.msg);
        setOpen(false);
        fetchAllUsers(
          page,
          limit,
          searchEmail,
          setUsers,
          setTotalPages,
          setLoading
        );
      }, 1000);
    }
  };

  const handleSearch = (e) => {
    setSearchEmail(e.target.value);
    setPage(1); // Reset to first page after search
    updateUrlParams(1, limit);
  };

  const handlePageChange = (selectedPage) => {
    const newPage = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    setPage(newPage);
    updateUrlParams(newPage, limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setPage(1);
    updateUrlParams(1, newLimit);
  };

  const columns = [
    { name: "First Name", selector: (row) => row.firstName, sortable: true },
    { name: "Last Name", selector: (row) => row.lastName, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    {
      name: "Phone Number",
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: "Total Posts",
      selector: (row) => row.posts.length,
      sortable: true,
    },
    {
      name: "",
      cell: (row) => (
        <div className="donates-btns-users">
          <button className="donate-btn" onClick={() => handleView(row)}>
            View
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "",
      cell: (row) => (
        <div className="donates-btns-users">
          <button
            className="donate-btn"
            onClick={() => {
              setOpen(true);
              setUserToDelete(row);
            }}
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <ToastContainer />
      <Header />
      <div className="below-header">
        <p>
          <NavLink to={"/"}>Home</NavLink>
          <span>/</span>
          <a href={location.pathname} className="aCustom">Users</a>
        </p>
      </div>
      <div className="custom_container">
        <div className="search-bar-users search_head">
          <div className="topHeading">
            <h2>Users</h2>
          </div>
          <div className="search_box">
            <input
              type="text"
              placeholder="Search by email..."
              value={searchEmail}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      {loading ? (
        <div className="container loading-dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      ) : (
        <>
          <div className="custom_container">
            <DataTable
              className="custom_table_inner"
              columns={columns}
              data={users}
            />

            <div className="blog-paginate">
              <div className="limit-selection">
                <label htmlFor="limit">Users per page: </label>
                <select id="limit" value={limit} onChange={handleLimitChange}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={35}>35</option>
                  <option value={50}>50</option>
                </select>
              </div>
              {users && users.length > 0 && totalPages && totalPages > 1 && (
                <ReactPaginate
                  pageCount={totalPages}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  pageClassName={"page-item"}
                  activeClassName={"active"}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  forcePage={page - 1} // Sync with current page
                />
              )}
            </div>
          </div>

          <DialogBox
            open={open}
            handleClose={handleClose}
            handleAction={handleDelete}
            action={userToDelete}
            item={"user"}
          />
        </>
      )}
      <Footer />
    </>
  );
};

export default AllUsers;
